import styled from "styled-components";
import rowCommon from "./css/rowCommon";

const RowContainer = styled.div`
	${rowCommon}
`;

export default RowContainer;
